import React, { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { PageWrapper } from "@/components/PageWrapper";
import DemandSheet from "@/components/DemandSheet";
import { getAddressDemandReport } from "@/services/demandService";
import "./DemandReportPage.scss";

export const DEMAND_REPORT_PATH = "/demand-report";

export const problemOf = (error) =>
  error?.response?.status === 400
    ? "We could not find that address. Add the city and state."
    : error?.response?.data?.message || "The report did not load. Try again.";

const DemandReportPage = () => {
  const [address, setAddress] = useState("");
  const [problem, setProblem] = useState("");
  const report = useMutation({
    mutationFn: (value) => getAddressDemandReport(value),
    onError: (error) => setProblem(problemOf(error)),
  });
  const data = report.data?.data;

  const submit = (event) => {
    event.preventDefault();
    if (address.trim().length < 5) {
      setProblem("Enter the street address, city and state.");
      return;
    }
    setProblem("");
    report.mutate(address.trim());
  };

  return (
    <PageWrapper>
      <main className="demand-report-page">
        <form className="demand-report-page__form" onSubmit={submit} noValidate>
          <label className="demand-report-page__label" htmlFor="demand-report-address">
            Demand report for a CMA
          </label>
          <div className="demand-report-page__line">
            <input
              id="demand-report-address"
              className="demand-report-page__input"
              value={address}
              onChange={(event) => setAddress(event.target.value)}
              placeholder="Property address"
              autoComplete="street-address"
              maxLength={200}
            />
            <button type="submit" className="btn btn-primary demand-report-page__button" disabled={report.isPending}>
              {report.isPending ? "Making the report…" : "Make the report"}
            </button>
            {data ? (
              <button type="button" className="demand-report-page__print" onClick={() => window.print()}>
                Print or save as PDF
              </button>
            ) : null}
          </div>
          {problem ? (
            <p className="demand-report-page__problem" role="alert">
              {problem}
            </p>
          ) : null}
        </form>
        {data ? (
          <div className="demand-report-page__sheet">
            <DemandSheet
              title={`Buyer demand near ${data.address}`}
              countLine={`Buyer Want‑Listings that fit homes in ZIP ${data.area?.zip || ""}`.trim()}
              demand={data.demand}
              howWeCount="We count live Buyer Want-Listings from agents in this network whose area covers this ZIP code. Counts are ranges and never name a buyer or their agent."
              agent={data.agent}
              branding={data.branding}
              generatedAt={data.generatedAt}
            />
          </div>
        ) : null}
      </main>
    </PageWrapper>
  );
};

export default DemandReportPage;
